import React from "react";
import { useTranslation } from "react-i18next";
import "./ShareCaseChoice.css";

const IDocument = () => (
  <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
    <polyline points="14 2 14 8 20 8" />
    <line x1="16" y1="13" x2="8" y2="13" />
    <line x1="16" y1="17" x2="8" y2="17" />
    <line x1="10" y1="9" x2="8" y2="9" />
  </svg>
);

const ILive = () => (
  <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" className="mcd-live-icon">
    <path d="M16.247 7.761a6 6 0 0 1 0 8.478" />
    <path d="M19.075 4.933a10 10 0 0 1 0 14.134" />
    <path d="M4.925 19.067a10 10 0 0 1 0-14.134" />
    <path d="M7.753 16.239a6 6 0 0 1 0-8.478" />
    <circle cx="12" cy="12" r="2" />
  </svg>
);

export default function ShareCaseChoice({ onBack, onStandardCase, onGoLive }) {
  const { t } = useTranslation();

  return (
    <section className="mcd-share" aria-label={t("caseDiscussions.shareCaseTitle") || "Share a Medical Case"}>
      <button type="button" className="mcd-share__back" onClick={onBack}>
        <span aria-hidden="true">←</span>
        {t("caseDiscussions.backToCases") || "Back to Cases"}
      </button>

      <header className="mcd-share__header">
        <h2>{t("caseDiscussions.shareCaseTitle") || "Share a Medical Case"}</h2>
        <p>{t("caseDiscussions.shareCaseSubtitle") || "Choose how you'd like to present your case"}</p>
      </header>

      <div className="mcd-share__grid">
        <article className="mcd-share-card mcd-share-card--standard">
          <div className="mcd-share-card__icon mcd-share-card__icon--standard">
            <IDocument />
          </div>
          <h3>{t("caseDiscussions.standardCaseTitle") || "Standard Case"}</h3>
          <p>
            {t("caseDiscussions.standardCaseDesc") ||
              "Create a detailed written case with images, findings, and discussion points. Colleagues can review and comment asynchronously."}
          </p>
          <ul>
            <li>{t("caseDiscussions.standardCaseItem1") || "Structured case presentation"}</li>
            <li>{t("caseDiscussions.standardCaseItem2") || "Image and file attachments"}</li>
            <li>{t("caseDiscussions.standardCaseItem3") || "Threaded discussions"}</li>
            <li>{t("caseDiscussions.standardCaseItem4") || "Permanent case archive"}</li>
          </ul>
          <button type="button" className="mcd-share-card__cta mcd-share-card__cta--standard" onClick={onStandardCase}>
            {t("caseDiscussions.createStandardCase") || "Create Standard Case"} <span aria-hidden="true">→</span>
          </button>
        </article>

        <article className="mcd-share-card mcd-share-card--live">
          <span className="mcd-share-card__live-pill">{t("caseDiscussions.live") || "LIVE"}</span>
          <div className="mcd-share-card__icon mcd-share-card__icon--live">
            <ILive />
          </div>
          <h3>{t("caseDiscussions.goLiveTitle") || "Go Live"}</h3>
          <p>
            {t("caseDiscussions.goLiveLongDesc") ||
              "Stream a live case presentation with real-time video and chat. Engage with colleagues instantly and get immediate feedback."}
          </p>
          <ul>
            <li>{t("caseDiscussions.goLiveItem1") || "Live video streaming"}</li>
            <li>{t("caseDiscussions.goLiveItem2") || "Real-time chat interaction"}</li>
            <li>{t("caseDiscussions.goLiveItem3") || "Screen sharing capability"}</li>
            <li>{t("caseDiscussions.goLiveItem4") || "Live viewer count"}</li>
          </ul>
          <button type="button" className="mcd-share-card__cta mcd-share-card__cta--live" onClick={onGoLive}>
            {t("caseDiscussions.startLiveStream") || "Start Live Stream"} <span aria-hidden="true">→</span>
          </button>
        </article>
      </div>
    </section>
  );
}
